// Lala Elite — sistema de niveles enterprise.
// IDs estables: partner > key > challenge > commercial; recuperación se mantiene separada.
export const TIER_META = {
  partner: {
    label: "Partner",
    humanLabel: "Partner",
    gem: "Platino",
    gemIcon: "◆",
    gemColor: "#0033AD",
    tagline: "La estrella brilla · lideras y creces junto a Lala",
    description: "Socio estratégico de la familia LALA. Crece de forma sostenida junto con Grupo Lala en los seis pilares.",
    color: "#0033AD",
    className: "tier-partner",
    range: "9.5 – 10",
    order: 3,
  },
  key: {
    label: "Key",
    humanLabel: "Key",
    gem: "Oro",
    gemIcon: "◆",
    gemColor: "#D4A437",
    tagline: "La estrella asciende · eres un socio confiable de la familia Lala",
    description: "Resultados consistentes y de alto valor. Camino claro hacia el liderazgo compartido con Lala.",
    color: "#D4A437",
    className: "tier-key",
    range: "8.5 – 9.4",
    order: 2,
  },
  challenge: {
    label: "Challenger",
    humanLabel: "Challenger",
    gem: "Plata",
    gemIcon: "◆",
    gemColor: "#94A3B8",
    tagline: "La estrella evoluciona · construyes confianza con resultados consistentes",
    description: "Cumple lo acordado y tiene un plan claro para seguir avanzando junto con Lala.",
    color: "#64748B",
    className: "tier-challenge",
    range: "7.5 – 8.4",
    order: 1,
  },
  commercial: {
    label: "Commercial",
    humanLabel: "Commercial",
    gem: "Bronce",
    gemIcon: "◆",
    gemColor: "#B87333",
    tagline: "La estrella se forma · inicias el camino con el acompañamiento del equipo Lala",
    description: "Inicia el camino dentro de la familia LALA Elite. Plan de acompañamiento activo con Lala.",
    color: "#B87333",
    className: "tier-commercial",
    range: "5.8 – 7.4",
    order: 0,
  },
  recuperacion: {
    label: "En Recuperación",
    humanLabel: "En Recuperación",
    gem: "Recuperación",
    gemIcon: "⚠",
    gemColor: "#F59E0B",
    tagline: "Camino de recuperación · plan de mejora activo",
    description: "Score por debajo del mínimo esperado. Plan de recuperación con owner asignado. No visible al público.",
    color: "#F59E0B",
    className: "tier-recuperacion",
    range: "< 5.8",
    order: -1,
  },
};

// UI ordering: Bronce → Plata → Oro → Platino (Recuperación se muestra cuando aplica).
export const TIER_KEYS = ["commercial", "challenge", "key", "partner"];

export const TIER_BADGE_IMG = {
  commercial: "/badges/nivel_commercial.png",
  challenge: "/badges/nivel_challenger.png",
  key: "/badges/nivel_key.png",
  partner: "/badges/nivel_partner.png",
};

export const PILLARS = [
  { key: "calidad", label: "Calidad", description: "Cuidamos juntos lo que llega a millones de familias: especificaciones, certificaciones y procesos sin sorpresas." },
  { key: "costo", label: "Costo", description: "Construimos competitividad sostenible: precio justo, transparencia y eficiencias compartidas." },
  { key: "continuidad", label: "Continuidad de Negocio", description: "Estamos listos pase lo que pase: entregas a tiempo, capacidad disponible y planes ante imprevistos." },
  { key: "innovacion", label: "Innovación", description: "Avanzamos juntos: propuestas, mejoras y desarrollo conjunto que llevan a Lala más allá." },
  { key: "sustentabilidad", label: "Sostenibilidad", description: "Cuidamos el planeta como cuidamos lo nuestro: huella ambiental, prácticas regenerativas y evidencia ESG." },
  { key: "relacion", label: "Nivel de Servicio", description: "Entrega en tiempo y forma: puntualidad, cumplimiento de cantidad, calidad de servicio y colaboración en la operación diaria." },
];

export const PILLAR_KEYS = PILLARS.map((p) => p.key);

export function tierFromScore(score) {
  if (score == null) return "commercial";
  if (score >= 9.5) return "partner";
  if (score >= 8.5) return "key";
  if (score >= 7.5) return "challenge";
  if (score >= 5.8) return "commercial";
  return "recuperacion";
}

export const LEGACY_TIER_ALIAS = {
  platino: "partner",
  oro: "key",
  plata: "challenge",
  bronce: "commercial",
  sin_clasificar: "commercial",
  requiere_desarrollo: "recuperacion",
  recuperacion: "recuperacion",
  recuperación: "recuperacion",
};

export function normalizeTier(tier) {
  if (!tier) return "commercial";
  if (TIER_META[tier]) return tier;
  return LEGACY_TIER_ALIAS[tier] || "commercial";
}

export const CATEGORIES = ["Asépticos", "Empaques", "Ingredientes", "Materia prima cárnica", "Maquilas Co-Man", "Maquilas Co-Pack", "Transporte", "Automotriz y Logística", "Indirectos Industrial", "Indirectos comercial", "Servicios", "Comercio Exterior"];

export const LEVEL_LABELS = { 1: "Inicial", 2: "En Desarrollo", 3: "Competente", 4: "Elite" };

// Presentación continua en base 10: 1→1, 2→4, 3→7, 4→10.
export const toBase10 = (v) => {
  if (v == null) return null;
  const clamped = Math.max(1, Math.min(4, Number(v)));
  return Math.round(((clamped * 3) - 2) * 100) / 100;
};

export const BASE10_CAPTURE_BANDS = {
  1: "1.0–3.9",
  2: "4.0–6.9",
  3: "7.0–8.9",
  4: "9.0–10.0",
};

export const ROLE_LABELS = {
  admin: "Administrador",
  evaluator: "Evaluador",
  stakeholder: "Visualizador",
  buyer: "Category Manager",
  supplier: "Proveedor",
  tech_admin: "TI",
  owner: "DEV",
};

export const RECOGNITION_META = {
  platino: { label: "LALA Elite Platino", color: "#0033AD", icon: "◆" },
  oro: { label: "LALA Elite Oro", color: "#D4A437", icon: "◆" },
  plata: { label: "LALA Elite Plata", color: "#94A3B8", icon: "◆" },
  bronce: { label: "LALA Elite Bronce", color: "#B87333", icon: "◆" },
  requiere_desarrollo: { label: "Recuperación", color: "#E0162B", icon: "⚠" },
};
